<template>
  <div class="all_body">
    <div class="buy_success">
      <div class="buy_success_img">
        <img :src="deng" />
      </div>
      <div class="buy_success_title">您的订单已提交成功，等待系统收款确认 !</div>
      <div class="buy_success_button" @click="goMyCenter">返回个人中心（{{waitTime}}s）</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Buy_success",
  data() {
    return {
      deng: "./static/img/deng.png",
      waitTime: 5
    };
  },
  mounted() {
    let that = this;
    that.waitTime--;
    let timer = setInterval(function() {
      if (that.waitTime > 1) {
        that.waitTime--;
      } else {
        that.goMyCenter(timer);
        return false;
      }
    }, 1000);
  },
  methods: {
    goMyCenter(timer) {
      clearInterval(timer);
      this.$router.push("/p/System");
    }
  }
};
</script>
<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.buy_success {
  margin: 220px 0;
}
.buy_success_img {
  width: 70px;
  height: 57px;
  margin: 0 auto;
  animation: changDeg 3s linear 0.3s infinite;
}
.buy_success_img img {
  width: 100%;
  height: 100%;
}
.buy_success_title {
  margin-top: 40px;
  font-size: 30px;
  color: #343434;
  width: 100%;
  text-align: center;
  margin-bottom: 77px;
}
.buy_success_button {
  margin: 0 auto;
  width: 300px;
  height: 44px;
  background: #56b234;
  border-radius: 6px;
  line-height: 44px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
@keyframes changDeg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/sys/buy_success.vue